module.exports = __webpack_public_path__ + "static/LaptopPlatformES-b7c60fea32324da4b0781df5d98bd6e8.mp4";